
import MicrosoftLogo from '@/assets/login-providers/microsoft-logo.svg?inline';
import microsoftAuthConfig from '~/app/microsoftAuthConfig';

export default {
  components: {
    MicrosoftLogo
  },

  methods: {
    async login () {
      const { PublicClientApplication } = await import('@azure/msal-browser');

      const msal = new PublicClientApplication(microsoftAuthConfig);

      await msal.initialize();

      const redirect = this.$route.query.redirect;
      if (redirect) {
        sessionStorage.setItem('redirect_url', redirect);
      } else if (this.$route.path !== '/login') {
        sessionStorage.setItem('redirect_url', this.$route.fullPath);
      }

      try {
        msal.loginRedirect({});
      } catch (err) {
        console.error(err);
        // handle error
      }
    }
  }
};
